<template>
    <div>
        <div class="vx-row mb-base">
            <vx-card class="w-full ml-4 mr-4">
                <div class="vx-row ml-1">
                    <span class="vx-col">Data de fechamento:</span>
                </div>  
                <div class="vx-row ml-1">
                    <div class="vx-col sm:w-full md:w-4/12 lg:w-3/12 xl:w-3/12 w-full mb-4 ">
                        <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="date"></datepicker>
                    </div>
                    <div class="vx-col sm:w-full md:w-2/12 lg:w-2/12 xl:w-2/12 w-full">
                        <vs-button  type="relief" class="w-full"  @click="getClosingData()"> <a-icon type="filter" /> Filtrar</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
        
        <div class="vx-row" v-if="taxes.length == 0">
            <h4 class="w-full text-center"> Não há dados </h4>
        </div>
        <div class="vx-row" v-if="taxes.length > 0">
            <statistics-bar-card-taxes class="vx-col sm:w-full md:w-6/12 lg:w-4/12 xl:w-4/12 w-full" :dataTaxes="taxes" />
        </div>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import StatisticsBarCardTaxes from '@/components/statistics-cards/closing/StatisticsBarCardTaxes'
    import Datepicker from 'vuejs-datepicker';
    import * as lang from 'vuejs-datepicker/src/locale';

    export default {
        components : {
            StatisticsBarCardTaxes,
            Datepicker
        },

        data () {
            return {
                date: new Date(),
                languages: lang,
                highlightedFn : {
                    customPredictor(date) {
                        let today = new Date()
                        if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
                            return true;
                        }
                    }
                },
                datePeriod : {
                    from : '',
                    to : ''
                },
                taxes : []
            }
        },

        methods : {
            getClosingData () {
                this.clearStatisticsData()

                try{
                    let rangeDate = this.getRangeDate()
                    let companyId = this.$store.getters.getCompanyID;
                    firebase.firestore().collection(`/company/${companyId}/counters/closing/daily/`)
                        .where('date', '>=', rangeDate.from)
                        .where('date', '<=', rangeDate.to)
                        .onSnapshot(snapshot => {
                            snapshot.docChanges().forEach(change => {
                                if(change.type === "added") {
                                    this.updateTaxes(change)
                                }
                                if(change.type === "modified") {
                                    this.updateTaxes(change)
                                }
                            })
                        })
                } catch (err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro',
                        content: `Erro ao tentar filtrar fechamento: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            updateTaxes (change) {
                let data = change.doc.data()

                this.taxes = []
                if(change.doc.id == this.$options.filters.moment(this.date, 'YYYY-MM-DD')) {
                    if(data.hasOwnProperty('taxes')) {
                        Object.entries(data.taxes).forEach(tax => {
                            if(tax[1].description)
                                this.taxes.push({
                                    description : tax[1].description,
                                    type : tax[0],
                                    value : tax[1].value
                                })
                        })
                    }
                }
            },

            getRangeDate () {
                let fromDate = new Date(this.date);
                fromDate.setDate(fromDate.getDate()-7)
                fromDate.setHours(0)
                fromDate.setMinutes(0)
                fromDate.setSeconds(0)

                let toDate = new Date(this.date)
                toDate.setHours(23)
                toDate.setMinutes(59)
                toDate.setSeconds(59)

                return { from: fromDate, to: toDate }
            },

            clearStatisticsData () {
                this.taxes    = []
            }
        }
    }
</script>